var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14593_92359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8333 0H2.16667C0.97005 0 0 1.00736 0 2.25V15.75C0 16.9926 0.97005 18 2.16667 18H23.8333C25.03 18 26 16.9926 26 15.75V2.25C26 1.00736 25.03 0 23.8333 0Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75016 14.625C12.7417 14.625 15.1668 12.1066 15.1668 9C15.1668 5.8934 12.7417 3.375 9.75016 3.375C6.75862 3.375 4.3335 5.8934 4.3335 9C4.3335 12.1066 6.75862 14.625 9.75016 14.625Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2502 14.625C19.2417 14.625 21.6668 12.1066 21.6668 9C21.6668 5.8934 19.2417 3.375 16.2502 3.375C13.2586 3.375 10.8335 5.8934 10.8335 9C10.8335 12.1066 13.2586 14.625 16.2502 14.625Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0002 4.5C14.3158 5.52623 15.1668 7.16012 15.1668 9.00041C15.1668 10.8407 14.3158 12.4746 13.0002 13.5008C11.6845 12.4746 10.8335 10.8407 10.8335 9.00041C10.8335 7.16012 11.6845 5.52623 13.0002 4.5Z",
    fill: "#FF5F00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14593_92359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.b065b104dda164b7942602572f8683ff.svg";
export { ForwardRef as ReactComponent };